import AvEsController from './av.es.controller';

export default {
    bindings: {
        frontFilters: '=',
        filterToBack: '=',
        parametre: '=',
        listes: '<',
        libelles: '=',
        source: '<',
        domaine: '<',
        onUpdate: '&',
        onDelete: '&',
        dateApplication: '='
    },
    template: require('./aves.html'),
    controller: AvEsController
};
